// hooks/useRecaptcha.ts
import { useEffect } from 'react';

declare global {
  interface Window {
    grecaptcha: {
      enterprise: {
        ready: (callback: () => void) => void;
        execute: (siteKey: string, options: { action: string }) => Promise<string>;
      };
    };
  }
}

declare global {
  interface Window {
    localConfig: {
      recaptcha: {
        key: string;
      };
    };
  }
}

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY as string || window.localConfig.recaptcha.key;

export const useRecaptcha = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${SITE_KEY}`;
    script.async = true;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const getToken = (action: string): Promise<string> => {
    return new Promise((resolve, reject) => {
      window.grecaptcha.enterprise.ready(async () => {
        try {
          const token = await window.grecaptcha.enterprise.execute(SITE_KEY, { action });
          resolve(token);
        } catch (err) {
          reject(err);
        }
      });
    });
  };

  return { getToken };
};